import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { ResourceApi } from 'src/app/shared/apis/resource.api';
import { ActivityInfoParams, ActivityList } from 'src/app/shared/interfaces/bonus.interface';
import { BannerList } from 'src/app/shared/interfaces/resource.interface';
import { ResponseData } from 'src/app/shared/interfaces/response.interface';
import { cacheValue } from 'src/app/shared/service/general.service';
import { environment } from 'src/environments/environment';
import { KycService } from '../kyc/kyc.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DividendVipService {
  /** 活动列表订阅（依请求参数缓存） */
  private activitiesListCache = new Map<string, Observable<ActivityList>>();

  /** 当前是否认证*/
  kycStatus: boolean = false;

  /** 活动Banner订阅 */
  getActivitiesBannerList$?: Observable<ResponseData<BannerList[]>>;

  /** 最新优惠数量 */
  activityCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(
    private kycService: KycService,
    private appService: AppService,
    private bounsApi: BonusApi,
    private resourceApi: ResourceApi,
  ) {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      if (x?.kycGrade) {
        this.kycService.checkUserKycLevel(x.kycGrade).level > 0 && (this.kycStatus = true);
      }
    });
  }

  /**
   * 缓存活动列表
   *
   * @param params
   * @param params.equipment
   * @param params.productTypes 产品类型筛选，可多值，不带 = 不筛选
   * @returns 活动列表（相同参数共用缓存）
   */
  public getActivitiesList(params: ActivityInfoParams) {
    // 正規化 key：固定欄位順序、productTypes 排序，避免呼叫端寫法差異造成重複請求
    const cacheKey = `${params.equipment}|${[...(params.productTypes ?? [])].sort().join(',')}`;
    let activitiesList$ = this.activitiesListCache.get(cacheKey);
    if (!activitiesList$) {
      activitiesList$ = this.bounsApi
        .getActivityInfo(params)
        .pipe(environment.isApp ? cacheValue(0) : cacheValue(1000 * 60 * 10));
      this.activitiesListCache.set(cacheKey, activitiesList$);
    }
    return activitiesList$;
  }

  /**
   * 缓存活动banner
   *
   * @param params
   * @param params.equipment
   * @param params.bannerPageType
   */
  public getActivitiesBannersList(params: {
    bannerPageType: 'FrontPage' | 'GamesPage' | 'LotteryPage' | 'Promotion';
    equipment: string;
  }) {
    return (
      this.getActivitiesBannerList$ ??
      ((this.getActivitiesBannerList$ = this.resourceApi
        .getbannerlist(params.bannerPageType, params.equipment)
        .pipe(cacheValue(1000 * 60 * 10))),
      this.getActivitiesBannerList$)
    );
  }

  /**
   * 获取活动数量
   */
  getActivityCount() {
    this.bounsApi.getActivityCount({ equipment: this.appService.equipment }).subscribe(data => {
      this.activityCount$.next(data || 0);
    });
  }
}
